import React from "react";
import "./Header.scss";
import { Row, Col } from "react-bootstrap";
import { format } from "date-fns";
// Below is for import icons
import { IoMdCloseCircleOutline } from "react-icons/io";
import { MdLogout } from "react-icons/md";
// Below is for import the images
import NCLOGO from "../../Student/Assests/Images/NCLogo.png";
import { useNavigate, useLocation } from "react-router-dom";

import { FaAnglesLeft } from "react-icons/fa6";

import { SelectLanguageData } from "../../Redux/Reducers/Common/Language";
import { useSelector, useDispatch } from "react-redux";
import English from "../../ReusableComponents/Assessts/Images/English.png";
import Mathematics from "../../ReusableComponents/Assessts/Images/Mathematics.svg";
import Science from "../../ReusableComponents/Assessts/Images/Science.png";
import Hindi from "../../ReusableComponents/Assessts/Images/Hindi.png";
import Telugu from "../../ReusableComponents/Assessts/Images/Telugu.png";
import { QBSubjectnames } from "../../ReusableComponents/CommonFunctions";
import { YearDD } from "../../ReusableComponents/CommonApis";
import { AssessmentNameDates } from "../../ReusableComponents/CommonComponents";
import NCLAdminMenu from "./NCLAdminMenu";
import PrincipleMenu from "./PrincipleMenu";
import InstituteMenu from "./InstituteMenu";
import QBAdminMenu from "./QBAdminMenu";
import TeacherMenu from "./TeacherMenu";
const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const isActive = (path) => location.pathname.includes(path);
  // Below is for getting the user details
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const ASSName = useSelector((state) => state.ANameData.SName);

  const Sessionlogout = () => {
    if (location.pathname !== "/QBAdmin/PreviewQuestion") {
      sessionStorage.clear();
      localStorage.clear();
      navigate("/Login", { replace: true });
      window.location.reload();
    } else {
      navigate(-1);
      // if (!document.fullscreenElement) {
      document.exitFullscreen();
      // }
    }
  };
  //Logout Remove form AnswerSheet

  const DashboardLink = () => {
    switch (items.userTypeId) {
      case 10:
        navigate("/InstitutionAdmin");
        break;
      case 8:
        navigate("/InstitutionAdmin");
        break;
      case 7:
        if (location.pathname !== "/QBAdmin/PreviewQuestion") {
          navigate("/QBAdmin/QuestionBank", {
            state: { Tab: "SCQ" },
          });
        }
        break;
      case 4:
        if (
          location.pathname !== "/Student/Answersheet" &&
          location?.pathname !== "/Student/Results"
        ) {
          navigate("/Student");
        }
        break;
      case 3:
        navigate("/TeacherDashboard");
        break;
      case 2:
        navigate("/PrincipleDashboard");
        break;
      case 1:
        navigate("/NCLAdmin/StudentResponses");
        break;
    }
  };

  const SubjectLogos = () => {
    switch (ASSName || QBSubjectnames(items?.subjectId)) {
      case "English":
        return English;
      case "Mathematics":
        return Mathematics;
      case "Hindi":
        return Hindi;
        case "Telugu":
        return Telugu;
      default:
        return Science; 
    }
  };

  return (
    <div style={{ position: "sticky", top: "0px", zIndex: "1" }}>
      <div className="container-fluid Header-Maindiv">
        <Row className="alignitems">
          <Col md="3" sm="4" xs="4">
            <img src={NCLOGO} alt="Logo" className="LOGO" onClick={DashboardLink} />
          </Col>
          <Col md="6" sm="4" xs="3" className="dflex JCCenter SchoolName" style={items?.userTypeId === 2?{color:"#347363",fontWeight:"bold"}:{}}>
          {/* items?.userTypeId !== 2 &&  */}
            {(items?.userTypeId === 7 ||
              location?.pathname === "/Student/Answersheet" ? (
              <img src={SubjectLogos()} alt="Maths" className="Assessment-Logos" />
            ) : items?.userTypeId === 1 ? <NCLAdminMenu CheckPath={isActive} /> : items?.schoolName)  }
          </Col>

          {/* Below column is for user details */}
          <Col md="3" sm="4" xs="5" className="Header-icons dflex alignitems">
            <div className="User-details dflex flexd-column">
             {items?.userTypeId !== 2 && <span> {items.fullName}</span>}

              <span>
                {items?.lastLoginDate != "0001-01-01T00:00:00" && (
                  <> <b>Last Login :</b> {format( new Date(items?.lastLoginDate), "do MMM yyyy HH:mm" )} </>
                )}
              </span>
              <span> {items?.userTypeId === 4 ? items.studentId + " (Grade " + items.grade + ")" : ""} </span>
              {items?.userTypeId === 4 &&
                location.pathname === "/Student/Answersheet" && (
                  <span className="dflex JCCenter SchoolName"> {items?.schoolName} </span> )}
            </div>
            {location?.pathname !== "/Student/Answersheet" && (
              <>
                {isActive("/PreviewQuestion") ? (
                  <IoMdCloseCircleOutline title="Close" onClick={Sessionlogout} className="User-icon" />
                ) : (
                  <MdLogout title="Logout" onClick={Sessionlogout} className="User-icon" />
                )}
              </>
            )}
          </Col>
        </Row>
      </div>
        {items.userTypeId === 2 && ( <PrincipleMenu CheckPath={isActive} /> )}
      {(!isActive("/Student") || isActive("/NCLAdmin") || isActive("/StudentInformation")) &&
        // Below is NCL Admin
        !isActive("/QBReports") && !isActive("/QBAdminLogin") && !isActive("/AssessmentParameters") &&
        // !isActive("/InstitutionMaster")&&
        (
          <div className="Sub-Header">
            <div className="dflex JCCenter alignitems">

              {items?.userTypeId === 3 && ( <TeacherMenu CheckPath={isActive} /> )}

              {/* {items.userTypeId === 2 && ( <PrincipleMenu CheckPath={isActive} /> )} */}

              {(items?.userTypeId === 10 || items?.userTypeId === 8) && ( <InstituteMenu CheckPath={isActive} />)}

              {items?.userTypeId === 7 && location.pathname !== "/QBAdmin/PreviewQuestion" && ( <QBAdminMenu CheckPath={isActive} /> )}
            </div>
 
            { 
            // items?.userTypeId === "2" &&
            !isActive("/PrincipleDashboard") &&
              !isActive("/DownloadDetails") && !isActive("/Institution/Assessments%20Participation") &&
              !isActive("/QuestionStatus") && !isActive("/Practice%20Test%20Reports") &&
              !( isActive("/Progresstracker") && !isActive("/QBAdmin/Progresstracker/DrillDown") ) &&
              !( isActive("/QBAdmin/OverallDashboard") && !isActive("/QBAdmin/OverallDashboard/VerificationSTatus") ) && (
                <div className="dflex JSBetween" style={{ alignItems: "flex-start" }}>
                  {
                    // QBAdmin
                    ((!isActive("/QBAdmin/QuestionBank") || isActive("/ScenarioQuestions") ||
                      isActive("/AddEditScenario") || isActive("/AddUpdateQuestions") ||
                      isActive("/Remidation") || isActive("/TranslateScenario") ||
                      isActive("/TranslateQuestion") || isActive("/FilterScenarioQuestions")) &&
                      !isActive("/QBAdmin/PreviewQuestion") &&
                      // Below is for NCL Admin
                      !isActive("/NCLAdmin") && !isActive("/OMRResults") &&
                      !isActive("/SamagraDashboard") &&
                      // isActive("/Assessments/*") &&
                      // Below is Principle condition
                      !isActive("/TeacherDifficultyLevel") && !isActive("/TeacherDiffLevel") &&
                      !isActive("/PerformanceByeachSubject") &&
                      // !isActive("/StudentPerformance") &&
                      // Below is HQ admin Conditions
                      !isActive("/InstitutionAdmin")) || isActive("/DistrictPerformanceDetails") ||
                      isActive("/InstitutionAdmin/Performance/SWResults") ||
                      ((items?.userTypeId === "10" ||
                        isActive("/RegionPerformanceDetails")) && !isActive("/StudentResponses") &&
                        !isActive("/Assessments")) ? (
                      //  &&
                      // !isActive("/QBAdmin/QuestionBank")
                      <button className="BackNavigation Buttons dflex alignitems JCCenter gap-1"  onClick={() => navigate(-1)} > <FaAnglesLeft /> Back </button>
                    ) : (
                      <div></div>
                    )
                  }
                  {items?.userTypeId !== 4 && items?.userTypeId !== 7 && items?.userTypeId !== 1 &&
                    !isActive("/StudentInformation") && !isActive("/PrincipleAnswerSheetDetails") &&
                    !isActive("/ViewAnswerSheetDetails") &&
                    !isActive("/LoPerformance") && <AssessmentNameDates Path ={location.pathname}/>}
                  {
                    // Student
                    !isActive("/LoPerformanceReport") &&
                    // QB Module
                    items?.userTypeId !== 7 && !isActive("/StudentDetails") &&
                    !isActive("/QuestionStatusTrack") && !isActive("/OverallWeeklyQuestions") &&
                    !isActive("/InstitutionMaster") && !isActive("/Schools") &&
                    !isActive("/QBAdminLogin") && !isActive("/StudentDetails") &&
                    // Principle Module
                    !isActive("/Studentwiseresults") &&  !isActive("/AutobulkRegistrations") && (
                      <div className="" style={{ justifyContent: "end" }}>
                        {
                          // Below is for Student
                          !( isActive("/ViewAnswerSheetDetails") && isActive("/ViewAnswerSheetDetails/ViewAnswerSheet") ) &&
                          !isActive("/Remediation") && !isActive("/ReportCard") &&
                          !isActive("/Samagra/LoPerformance") && !isActive("/QuestionRating") &&
                          !isActive("/Question%20Paper") && !isActive("/InstitutionMaster") &&
                          !isActive("/Schools") && !isActive("/QBReports") &&
                          !isActive("/AssessmentParameters") && !isActive("/WeeklyTests") &&
                          !isActive("/AddTest") && !isActive("/AssessmentQuestionPaper") &&
                          (
                            <YearDD />
                          )
                        }
                      </div>
                    )
                  }
                </div>
              )}
          </div>
        )}
    </div>
  );
};
export default Header;